/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import firebase from 'firebase'
import { Button } from 'semantic-ui-react'

import utils from '../utils'

class FinanceMonthlyReport extends React.Component {
  fileReader = new FileReader()

  fileInputRef = React.createRef()

  downloadLinkRef = React.createRef()

  state = {
    downloading: false,
    downloadUrl: '',
  }

  uploadFile = async blob => {
    this.setState({ downloading: true })

    const { path } = this.props
    const storage = firebase.storage().ref().child(path)

    return storage.put(blob)
  }

  downloadFile = async snapshot => {
    const downloadUrl = await snapshot.ref.getDownloadURL()

    this.setState({ downloading: false, downloadUrl }, () => {
      this.downloadLinkRef.click()
    })
  }

  onDownloadClick = async () => {
    const { getData } = this.props

    const data = getData()
    const blob = utils.helpers.convertCsvToExcel(data)
    const snapshot = await this.uploadFile(blob)

    this.downloadFile(snapshot)
  }

  render() {
    const { downloading, downloadUrl } = this.state
    const { disabled, label, ...props } = this.props

    return (
      <React.Fragment>
        <Button
          {...props}
          disabled={downloading || disabled}
          loading={downloading}
          onClick={this.onDownloadClick}
        >
          {label || 'Download Report'}
        </Button>
        <a
          href={downloadUrl}
          ref={ref => {
            this.downloadLinkRef = ref
          }}
          hidden
        />
      </React.Fragment>
    )
  }
}

export default FinanceMonthlyReport



// WEBPACK FOOTER //
// ./src/lib/DownloadFileButton.js